import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { envApiUrl } from './envApiUrl';

export const useFilesOnly = (mydayId: number) => {
  return useQuery({
    queryKey: ['useFilesOnly', mydayId],
    queryFn: () =>
      axios
        .get(`${envApiUrl}/files/`, {
          headers: {
            'Content-Type': 'application/json',
            'content-type': 'multipart/form-data',
            mydayId,
          },
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'x-csrf-token',
        })
        .then((response) => {
          return response.data;
        }),
  });
};
